import React, { useState, useEffect } from "react";
import { Input, InputNumber } from "antd";
import { getFormattedNumber } from "utils/common";

const Text = (props) => {
	//when initialised as null, the state doesn't get updated when defaultValue changes
	const {
		defaultValue,
		dispatch,
		name,
		isNew,
		questionId,
		row,
		dataType,
		prefix,
		suffix,
		options,
		...otherProps
	} = props;
	const [state, setState] = useState(defaultValue);
	const [isTouched, setIsTouched] = useState(false);
	const [answerAdded, answerEdited] = dispatch;

	const { wordCount } = options || {};

	//reset the state when new default value is received
	//this is necessary when an async thunk changes values
	//but the state inside the component does not get reset
	useEffect(() => {
		setState(defaultValue);
	}, [defaultValue]);

	const handleDispatch = () => {
		if (isTouched) {
			let data = {
				questionId: questionId,
				value: state,
				id: name,
				row: row,
				dataType: dataType,
			};
			if (!isNew) answerEdited(data);
			else answerAdded(data);
			setIsTouched(false);
		}
	};
	const handleKeyDown = (e) => {
		if (e.which !== 9) setIsTouched(true); //not dirty on tab
		if (e.which === 13) {
			handleDispatch();
		}
	};
	const currencyFormatter = (value) =>
		getFormattedNumber(value);
	const numericFormatter = (value) =>
		getFormattedNumber(value);
	const numericParser = (value) => value.replace(/\$\s?|(,*)/g, "");

	return dataType === "numeric" || dataType === "currency" ? (
		<InputNumber
			defaultValue={defaultValue}
			onChange={(value) => setState(value)}
			onKeyDown={handleKeyDown}
			onBlur={handleDispatch}
			value={!isTouched ? defaultValue : state}
			{...otherProps}
			formatter={
				dataType === "currency" ? currencyFormatter : numericFormatter
			}
			parser={numericParser}
			controls={false} //turns off useless +/- buttons
			className="text-align-right"
			style={{ width: "100%" }}
			addonBefore={dataType === "currency" ? "$" : null}
		/>
	) : (
		<>
			<Input
				defaultValue={defaultValue}
				onChange={(e) => setState(e.target.value)}
				onKeyDown={handleKeyDown}
				onBlur={handleDispatch}
				value={!isTouched ? defaultValue : state}
				size="medium"
				prefix={prefix}
				suffix={suffix}
				{...otherProps}
			/>
			{wordCount && (
				<span style={{ fontSize: "small", color: "#aaa" }}>
					(
					{`${state ? state.length : 0} of ${
						wordCount?.max
					} characters`}
					)
				</span>
			)}
		</>
	);
};

export default Text;
